module.exports = __webpack_public_path__ + "img/partner_partner.de0fe810.png";